import { z } from 'zod';
const boolish = z
    .union([z.boolean(), z.enum(['true', 'false', '1', '0'])])
    .transform((v) => v === true || v === 'true' || v === '1');
export const localGraphQuerySchema = z.object({
    hops: z.coerce.number().int().min(1).max(3).default(1),
    limit: z.coerce.number().int().min(1).max(2000).default(300),
});
export const globalGraphQuerySchema = z.object({
    type: z.string().optional(),
    includeUnresolved: boolish.default(false),
});
//# sourceMappingURL=graph.js.map